/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M17.204 2.7H6.796A4.096 4.096 0 0 0 2.7 6.796v10.408A4.096 4.096 0 0 0 6.796 21.3h10.408a4.096 4.096 0 0 0 4.096-4.096V6.796A4.096 4.096 0 0 0 17.204 2.7Z",
  fill: "url(#gadorue__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 5.92c-1.81 0-3.547.599-4.827 1.665-1.28 1.067-2 2.513-2 4.021.002.981.308 1.945.89 2.798.58.854 1.417 1.567 2.427 2.071a5.403 5.403 0 0 1-1.194 1.671 7.311 7.311 0 0 0 2.773-1.089 8.105 8.105 0 0 0 1.931.236c1.81 0 3.547-.6 4.827-1.666 1.28-1.066 2-2.513 2-4.02 0-1.509-.72-2.955-2-4.022C15.547 6.52 13.811 5.92 12 5.92Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gadorue__a",
  x1: 12.148,
  y1: 20.065,
  x2: 12.148,
  y2: 5.008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0CBD2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5BF675"
})))), "0 0 24 24", "ColoredImessage");